import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from "dayjs";
import { orderBy, pickBy } from "lodash";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "promote-list",
  data: function data() {
    return {
      searchForm: {
        count: 20,
        page: 1,
        status: "0,3"
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      remarkDialogVisible: false,
      currentRemarkObj: {},
      imPushRecord: [],
      imPushRecordDialogVisible: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    goChatRecord: function goChatRecord(row) {
      window.open("#/im/chat/record?userId=".concat(row.to_user_id, "&otherId=").concat(row.from_user_id));
    },
    imPushRecordDialog: function imPushRecordDialog(row) {
      console.log(row.records);
      this.imPushRecord = row.records;
      this.imPushRecordDialogVisible = true;
    },
    goGroupSendMsg: function goGroupSendMsg(row) {
      this.$router.push({
        path: "/im/group-send/message",
        query: {
          houseId: row.house_id,
          promoteId: row.id
        }
      });
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/house/update",
        query: {
          id: row.house_id,
          userId: row.user_id,
          from: this.$operationLog.editFrom({
            user_type: row.user_type,
            status: row.house_audit_status
          })
        }
      });
    },
    stickHouse: function stickHouse(id) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.stickHouse({
                houseId: id
              });
            case 1:
              _this2.$message.success("操作成功");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    batchStick: function batchStick() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var ids;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              ids = [];
              _this3.tableData.forEach(function (item) {
                if (item.status == 3) {
                  ids.push(item.house_id);
                }
              });
              _this3.$confirm("\u6279\u91CF\u7F6E\u9876".concat(ids.length, "\u6761\u63A8\u5E7F\u4E2D\u623F\u6E90"), "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _this3.stickHouse(ids);

                      // 操作上报
                      _this3.$operationLog.push({
                        code: "bulkpin",
                        operationType: "batch_operation_top"
                      });
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              }))).catch(function () {});
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updatePromoteStatus: function updatePromoteStatus(row, status) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _row$quarterScore, quarterScore, res, title;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(row.house_audit_status != 4 && status == 3)) {
                _context6.n = 1;
                break;
              }
              _this4.$message.error("该房源不是在线状态，请处理后再开始推广");
              return _context6.a(2);
            case 1:
              _row$quarterScore = row.quarterScore, quarterScore = _row$quarterScore === void 0 ? {} : _row$quarterScore;
              if (!(status == 3)) {
                _context6.n = 4;
                break;
              }
              if (!(quarterScore !== null && quarterScore !== void 0 && quarterScore.level && ["C", "D"].includes((quarterScore === null || quarterScore === void 0 ? void 0 : quarterScore.level) || ""))) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, _this4.$message.error("该季度用户等级为 C 或 D，无法进行推广。"));
            case 2:
              _context6.n = 3;
              return _this4.$api.promotionCheck({
                userId: row.user_id
              });
            case 3:
              res = _context6.v;
              if (res.data) {
                _context6.n = 4;
                break;
              }
              return _context6.a(2, res.msg && _this4.$message.error(res.msg));
            case 4:
              title = status == 3 ? "设置为推广开始， 是否继续?" : "设置为不通过， 是否继续?";
              _this4.$confirm(title, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                var res;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      if (!row.group) {
                        _context5.n = 2;
                        break;
                      }
                      _context5.n = 1;
                      return _this4.$api.updatePromote({
                        id: row.id,
                        status: status
                      });
                    case 1:
                      res = _context5.v;
                      _context5.n = 4;
                      break;
                    case 2:
                      _context5.n = 3;
                      return _this4.$api.updatePromoteStatus({
                        id: row.id,
                        status: status == 3 ? 1 : status
                      });
                    case 3:
                      res = _context5.v;
                    case 4:
                      if (res.data) {
                        if (status == 1) {
                          _this4.$message.success("该房源已推广");
                        } else {
                          _this4.$message.success("操作成功");
                        }
                        _this4.getData();
                        if (status == 3) {
                          // 操作上报
                          _this4.$operationLog.push({
                            code: "pass",
                            houseId: row.house_id,
                            userId: row.user_id
                          });
                        } else {
                          // 操作上报
                          _this4.$operationLog.push({
                            code: "reject",
                            houseId: row.house_id,
                            userId: row.user_id
                          });
                        }
                      } else {
                        _this4.$message.error(res.msg);
                      }
                    case 5:
                      return _context5.a(2);
                  }
                }, _callee5);
              }))).catch(function () {});
            case 5:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.getData();
    },
    getUsersTagList: function getUsersTagList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              userIds = [];
              _this5.tableData.forEach(function (item) {
                if (userIds.indexOf(item.user_id) == -1) {
                  userIds.push(item.user_id);
                }
              });
              _context8.n = 1;
              return _this5.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context8.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.n) {
                    case 0:
                      _this5.tableData.forEach(function (item, index) {
                        if (item.user_id == key) {
                          _this5.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context7.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context8.n = 4;
                break;
              }
              key = _t2.value;
              return _context8.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context8.n = 2;
              break;
            case 4:
              return _context8.a(2);
          }
        }, _callee7);
      }))();
    },
    getData: function getData(type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res, oldEndTime, userIds, quarterIds;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (type === "search") {
                _this6.searchForm.page = 1;
              }
              _this6.tableLoading = true;
              _context9.n = 1;
              return _this6.$api.getPromoteListV2(pickBy(_this6.searchForm));
            case 1:
              res = _context9.v;
              oldEndTime = parseInt(+new Date() / 1000 + 24 * 3600);
              userIds = [];
              quarterIds = [];
              res.data.forEach(function (item) {
                item.user = {
                  name: item.user_name,
                  id: item.user_id,
                  phone: item.user_phone,
                  avatar: item.user_avatar,
                  user_type: item.user_type,
                  user_type_status: item.user_type_status,
                  user_type_account_status: item.user_type_account_status,
                  landlord_status: item.landlord_status,
                  tenant_status: item.tenant_status,
                  scene: item.user_scene,
                  disable_send_msg_at: item.disable_send_msg_at
                };
                item.userTag = [];
                var userType = item.user_type;
                if (!userType) userIds.push(item.user_id);
                if (userType === 3) quarterIds.push(item.user_id);
                if (_this6.searchForm.status == "0,3" || _this6.searchForm.status == "3") {
                  if (oldEndTime > item.promote_time && item.status == 1 && !item.group && !item.index) {
                    item.status = 3;
                  }
                }
                item.pay_time = dayjs(item.pay_time * 1000).format("YYYY-MM-DD HH:mm:ss");
                item.house_created_time = dayjs(item.house_created_time * 1000).format("YYYY-MM-DD HH:mm:ss");
              });
              _this6.tableData = res.data;
              _this6.total = res.page.total;
              _this6.tableLoading = false;
              _this6.getUserScoreList(userIds);
              _this6.getQuarterScoreList(quarterIds);
              _context9.n = 2;
              return _this6.getUsersTagList();
            case 2:
              _this6.getUserListByIds(_this6.tableData, "user_id");
            case 3:
              return _context9.a(2);
          }
        }, _callee8);
      }))();
    },
    getQuarterScoreList: function getQuarterScoreList(userIds) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (userIds.length) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              _context0.n = 2;
              return _this7.$api.queryQuarterScoreById({
                userIds: userIds
              });
            case 2:
              res = _context0.v;
              if (res && res.data.length) {
                _this7.tableData.forEach(function (item) {
                  var quarterScore = res.data.find(function (score) {
                    return score.userId === item.user_id;
                  });
                  _this7.$set(item, "quarterScore", quarterScore || {});
                });
              }
            case 3:
              return _context0.a(2);
          }
        }, _callee9);
      }))();
    },
    getUserScoreList: function getUserScoreList(userIds) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              userIds = _toConsumableArray(new Set(userIds));
              _context1.n = 1;
              return _this8.$api.queryUserScoreById({
                userIds: userIds
              });
            case 1:
              res = _context1.v;
              if (res && res.data.length) {
                _this8.tableData.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.user_id;
                  });
                  _this8.$set(item, "userScore", userScore || {});
                });
              }
            case 2:
              return _context1.a(2);
          }
        }, _callee0);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var res;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return _this9.$api.getHouseFilterType();
            case 1:
              res = _context10.v;
              _this9.filterList = res.data;
            case 2:
              return _context10.a(2);
          }
        }, _callee1);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this0 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this0.searchForm.district = "";
            _this0.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    }
  }
};